import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { CompatModule } from './compat/compat.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(CompatModule);



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/main-compat.ts